const VOUCHER_INITIAL_STATE = {
  name: '',
  voucherCodes: [],
};

export { VOUCHER_INITIAL_STATE };
